import React from 'react';
import { UserPlusIcon, FileTextIcon, CheckCircle2Icon, RocketIcon } from 'lucide-react';
export function HowItWorksB2B() {
  const steps = [{
    number: '01',
    icon: <UserPlusIcon className="h-8 w-8" data-id="element-832" />,
    title: 'Regístrate como partner',
    description: 'Crea tu cuenta de corredor o inmobiliaria en minutos. Sin costo, sin compromiso.'
  }, {
    number: '02',
    icon: <FileTextIcon className="h-8 w-8" data-id="element-833" />,
    title: 'Envía a tus clientes',
    description: 'Comparte el link de evaluación con tus compradores. Ellos completan el formulario en 3 minutos.'
  }, {
    number: '03',
    icon: <CheckCircle2Icon className="h-8 w-8" data-id="element-834" />,
    title: 'Recibe resultados rápidos',
    description: 'En 24-48 horas tus clientes tienen respuesta de múltiples instituciones financieras.'
  }, {
    number: '04',
    icon: <RocketIcon className="h-8 w-8" data-id="element-835" />,
    title: 'Cierra la venta',
    description: 'Con crédito pre-aprobado, tu cliente firma más rápido. Tú cobras tu comisión antes.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-836">
      <div className="container mx-auto max-w-7xl px-4" data-id="element-837">
        <div className="text-center mb-12 md:mb-16" data-id="element-838">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4" data-id="element-839">
            Cómo funciona para corredores
          </h2>
          <p className="text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-840">
            Cuatro pasos simples para acelerar tus ventas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-841">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-842">
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow h-full" data-id="element-843">
                {/* Número */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center border-4 border-white" data-id="element-844">
                  <span className="text-xl font-bold bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] bg-clip-text text-transparent" data-id="element-845">
                    {step.number}
                  </span>
                </div>

                {/* Icono */}
                <div className="mb-6" data-id="element-846">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] p-0.5 shadow-md" data-id="element-847">
                    <div className="w-full h-full bg-blue-50 rounded-2xl flex items-center justify-center text-[#2B5FD9]" data-id="element-848">
                      {step.icon}
                    </div>
                  </div>
                </div>

                {/* Contenido */}
                <h3 className="text-lg font-bold text-[#0A1628] mb-3" data-id="element-849">
                  {step.title}
                </h3>
                <p className="text-sm text-[#6B7280] leading-relaxed" data-id="element-850">
                  {step.description}
                </p>
              </div>

              {/* Línea conectora (excepto en el último) */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-[#2B5FD9] to-purple-500 opacity-30" data-id="element-851" />}
            </div>)}
        </div>
      </div>
    </section>;
}